import { render, staticRenderFns } from "./analytics.component.vue?vue&type=template&id=41f19224&scoped=true"
import script from "./analytics.component.vue?vue&type=script&lang=js"
export * from "./analytics.component.vue?vue&type=script&lang=js"
import style0 from "./analytics.component.vue?vue&type=style&index=0&id=41f19224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f19224",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
